import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import { defValueDepartamentoFinanceiro } from "../../../types/api/financeiro/pesquisar-departamentos-financeiros";
import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";
import { IDataDepartamentosFinanceiros } from "../../../types/api/financeiro/pesquisar-departamentos-financeiros";

export default function SelectDepartamentoFinanceiro({
  value,
  onChange,
  required = false,
  error = false,
}: SelectSimpleApiQueryProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  const inputLabel = value ? `${value.id} - ${value.nome}` : "";

  return (
    <>
      <TextField
        {...{ required, error }}
        label={`Departamento`}
        variant="outlined"
        fullWidth
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          input: { readOnly: true }
        }}
        value={inputLabel}
        helperText={error ? "Campo obrigatório" : ""}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose }}
            title="Selecionar departamento"
            queryPath="/financeiro/configuracoes/pesquisar-departamentos"
            getItemKey={(item) => item.id}
            getItemLabel={(item) => `${item.id} - ${item.nome}`}
            defaultValue={value || defValueDepartamentoFinanceiro}
            onChange={(value) => {
              onChange(value as IDataDepartamentosFinanceiros);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSimpleApiQueryProps {
  value: IDataDepartamentosFinanceiros | null;
  onChange: (arg: IDataDepartamentosFinanceiros | null) => void;
  error?: boolean;
  required?: boolean;
}
